
import { preact, JSX, $$ } from "../../Core/References";

export interface IBaseComponentProps
{
    style?: JSX.CSSProperties;
    ref?: any;
}

export abstract class BaseComponent<TProps extends IBaseComponentProps = IBaseComponentProps, TState = {}> extends preact.Component<IBaseComponentProps, TState>
{
    public Container: HTMLElement;
    public override props: TProps;
    private static _idCounter = 0;
    private _id: string;
    private _childControls: BaseComponent<any>[] = [];

    constructor(props: TProps)
    {
        super(props);
        this.props = props;
        BaseComponent._idCounter++;
        this._id = "c" + BaseComponent._idCounter;
        this._registerContainer = this._registerContainer.bind(this);
    }

    override context: any;
    override state: TState;
    
    public static isComponent(element: HTMLElement | BaseComponent): element is BaseComponent
    {
        return !(element instanceof HTMLElement);
    }

    public override componentDidMount(): void
    {
       
    }

    protected _registerContainer(container: HTMLElement)
    {
        if (!container)
        {
            this.Container = null;
            return;
        }

        this.Container = container;
        if (this.props?.style)
        {
            let style = this.props.style;
            if (style)
            {
                for (var member in style)
                {
                    if (member === "display" && style[member] === "none")
                    {
                        //need to keep track of what the display was set to, so that when it is shown
                        //we can revert back to what it was.  $$.hide/$$.show handles all that for us.
                        $$.hide(this.Container);
                    }
                    else
                    {
                        this.Container.style[member] = style[member];
                    }
                }
            }
        }
    }

    public updateProps(changedProps: TProps)
    {
        let propsChanged = [];
        for (let propName in changedProps)
        {
            if (this.props[propName] === changedProps[propName])
            { 
                this.props[propName] = changedProps[propName];
                propsChanged.push(propName);
            }
        }

        if (propsChanged.length > 0)
        {
            this.propertiesChanged(propsChanged);
        }
    }

    protected propertiesChanged(propsChanged: Array<keyof TProps>)
    {
        
    }

    public dispose()
    {
        for (let childControl of this._childControls)
        {
            childControl.dispose();
        }
    }

    public get_id(): string
    {
        return this._id;
    }

    hide()
    {
        $$.hide(this.Container);
    }

    show()
    {
        $$.show(this.Container);
    }

    display(show)
    {
        $$.display(this.Container, show);
    }
}

